import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=11323d86&scoped=true"
var script = {}
import style0 from "./DownloadSection.vue?vue&type=style&index=0&id=11323d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11323d86",
  null
  
)

export default component.exports